import React from 'react'
import { BlogPostContentPlaceholderInterface } from 'common/types/entities/BlogPostContentPlaceholderInterface'
import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import HtmlAttrId from '../../../components/core/Sidebar/components/Settings/options/HtmlAttrId'

function BlogPostContentPlaceholderSettings({
  entity,
}: SettingsProps<BlogPostContentPlaceholderInterface>) {
  const { isMobile } = useDeviceModeContext()
  const updateProp = useUpdateProp(entity)

  return (
    <>
      <SizeAndPositionGroup
        padding={isMobile ? entity?.mobilePadding : entity.padding}
        updatePadding={updateProp(isMobile ? 'mobilePadding' : 'padding')}
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default BlogPostContentPlaceholderSettings
